export function objToBase64(obj) {
  const json = JSON.stringify(obj);
  const utf8 = new TextEncoder().encode(json);
  const binary = Array.from(utf8, (byteItem) => String.fromCharCode(byteItem)).join('');
  return btoa(binary);
}
